export const RECORD_EVENT_REQUEST = 'RECORD_EVENT_REQUEST';
